// Mapping of room layouts to photo section names
// This will be used for photo upload organization (Airbnb-style)

export interface PhotoSection {
  id: string;
  labelKey: string;
  description: string;
  required: boolean;
}

export const LAYOUT_DESCRIPTIONS: Record<string, string> = {
  "1R": "Single room with kitchen area (no separate kitchen)",
  "1K": "One room + separate Kitchen",
  "1DK": "One room + Dining Kitchen (8+ tatami)",
  "1LDK": "One room + Living Dining Kitchen (10+ tatami)",
  "2K": "Two rooms + separate Kitchen",
  "2DK": "Two rooms + Dining Kitchen",
  "2LDK": "Two rooms + Living Dining Kitchen",
  "3K": "Three rooms + separate Kitchen",
  "3DK": "Three rooms + Dining Kitchen",
  "3LDK+": "Three or more rooms + Living Dining Kitchen",
};

export const LAYOUT_PHOTO_SECTIONS: Record<string, PhotoSection[]> = {
  "1R": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "main_room",
      labelKey: "photoSectionMainRoom",
      description: "Photos of the main living/sleeping space",
      required: false,
    },
    {
      id: "kitchen_area",
      labelKey: "photoSectionKitchenArea",
      description: "Kitchen area within the room",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "1K": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "bedroom",
      labelKey: "photoSectionBedroom",
      description: "Main bedroom space",
      required: false,
    },
    {
      id: "kitchen",
      labelKey: "photoSectionKitchen",
      description: "Separate kitchen",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "1DK": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "bedroom",
      labelKey: "photoSectionBedroom",
      description: "Main bedroom space",
      required: false,
    },
    {
      id: "dining_kitchen",
      labelKey: "photoSectionDiningKitchen",
      description: "Dining and kitchen area",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "1LDK": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "living_room",
      labelKey: "photoSectionLivingRoom",
      description: "Living room space",
      required: false,
    },
    {
      id: "dining_kitchen",
      labelKey: "photoSectionDiningKitchen",
      description: "Dining and kitchen area",
      required: false,
    },
    {
      id: "bedroom",
      labelKey: "photoSectionBedroom",
      description: "Bedroom space",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "2K": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "room_1",
      labelKey: "photoSectionRoom1",
      description: "First room",
      required: false,
    },
    {
      id: "room_2",
      labelKey: "photoSectionRoom2",
      description: "Second room",
      required: false,
    },
    {
      id: "kitchen",
      labelKey: "photoSectionKitchen",
      description: "Separate kitchen",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "2DK": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "room_1",
      labelKey: "photoSectionRoom1",
      description: "First room",
      required: false,
    },
    {
      id: "room_2",
      labelKey: "photoSectionRoom2",
      description: "Second room",
      required: false,
    },
    {
      id: "dining_kitchen",
      labelKey: "photoSectionDiningKitchen",
      description: "Dining and kitchen area",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "2LDK": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "living_room",
      labelKey: "photoSectionLivingRoom",
      description: "Living room space",
      required: false,
    },
    {
      id: "dining_kitchen",
      labelKey: "photoSectionDiningKitchen",
      description: "Dining and kitchen area",
      required: false,
    },
    {
      id: "room_1",
      labelKey: "photoSectionRoom1",
      description: "First room/bedroom",
      required: false,
    },
    {
      id: "room_2",
      labelKey: "photoSectionRoom2",
      description: "Second room/bedroom",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "3K": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "room_1",
      labelKey: "photoSectionRoom1",
      description: "First room",
      required: false,
    },
    {
      id: "room_2",
      labelKey: "photoSectionRoom2",
      description: "Second room",
      required: false,
    },
    {
      id: "room_3",
      labelKey: "photoSectionRoom3",
      description: "Third room",
      required: false,
    },
    {
      id: "kitchen",
      labelKey: "photoSectionKitchen",
      description: "Separate kitchen",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "3DK": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "room_1",
      labelKey: "photoSectionRoom1",
      description: "First room",
      required: false,
    },
    {
      id: "room_2",
      labelKey: "photoSectionRoom2",
      description: "Second room",
      required: false,
    },
    {
      id: "room_3",
      labelKey: "photoSectionRoom3",
      description: "Third room",
      required: false,
    },
    {
      id: "dining_kitchen",
      labelKey: "photoSectionDiningKitchen",
      description: "Dining and kitchen area",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
  "3LDK+": [
    {
      id: "floor_plan",
      labelKey: "photoSectionFloorPlan",
      description: "Upload the floor plan image",
      required: true,
    },
    {
      id: "living_room",
      labelKey: "photoSectionLivingRoom",
      description: "Living room space",
      required: false,
    },
    {
      id: "dining_kitchen",
      labelKey: "photoSectionDiningKitchen",
      description: "Dining and kitchen area",
      required: false,
    },
    {
      id: "room_1",
      labelKey: "photoSectionRoom1",
      description: "First room/bedroom",
      required: false,
    },
    {
      id: "room_2",
      labelKey: "photoSectionRoom2",
      description: "Second room/bedroom",
      required: false,
    },
    {
      id: "room_3_plus",
      labelKey: "photoSectionRoom3Plus",
      description: "Additional rooms",
      required: false,
    },
    {
      id: "bathroom",
      labelKey: "photoSectionBathroom",
      description: "Bathroom and toilet",
      required: false,
    },
    {
      id: "genkan",
      labelKey: "photoSectionGenkan",
      description: "Entrance area",
      required: false,
    },
  ],
};

// Get photo sections for a given layout
export function getPhotoSectionsForLayout(layout: string): PhotoSection[] {
  return LAYOUT_PHOTO_SECTIONS[layout] ?? LAYOUT_PHOTO_SECTIONS["1K"] ?? [];
}

// Get layout description
export function getLayoutDescription(layout: string): string {
  return LAYOUT_DESCRIPTIONS[layout] || "";
}
